import { useCallback, useEffect, useState } from 'react';
import NchanSubscriber, { INchanSubscriber, SocketOptions } from 'nchan';

import {
  getSocketUrl,
  DEFAULT_SOCKET_OPTIONS,
  DEFAULT_RECONNECT_TIMEOUT,
} from 'utils/socketUtils';

export default function useSocket(
  url: string | (() => string | Promise<string>),
  options: SocketOptions = DEFAULT_SOCKET_OPTIONS,
) {
  const [socket, setSocket] = useState<INchanSubscriber | null>(null);

  const stopSocket = useCallback(() => {
    socket && socket.running && socket.stop();
  }, [socket]);

  const connect = useCallback(async () => {
    const socketUrl = await getSocketUrl(url);

    if (!socketUrl) return;

    const nchanSubscriber = new NchanSubscriber(socketUrl, options);
    nchanSubscriber.reconnectTimeout = DEFAULT_RECONNECT_TIMEOUT;
    nchanSubscriber.start();

    setSocket(nchanSubscriber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  useEffect(() => {
    connect();
  }, [connect]);

  useEffect(() => {
    return () => stopSocket();
  }, [stopSocket]);

  return [socket, connect, stopSocket] as const;
}
